import { createFileRoute } from "@tanstack/react-router";
import {
  Button,
  FieldError,
  Form,
  Input,
  Label,
  TextField,
} from "@heroui/react";
import { SubmitHandler, useForm } from "react-hook-form";

import { useCreateTariffsConfigurations } from "@/features/tariffs-configurations/use-tariffs-configurations.ts";

export const Route = createFileRoute("/dashboard/tariff/configuration/add")({
  component: RouteComponent,
});

interface IFormInput {
  title: string;

  costOfOneCourierVisit: number;
  fuelCostPerOrder: number;
  totalDepreciationPerOrder: number;
  tax: number;
  bankCommission: number;
  plannedMarkup: number;
}

function RouteComponent() {
  const { mutateAsync, isPending } = useCreateTariffsConfigurations();

  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm<IFormInput>();

  const onSubmit: SubmitHandler<IFormInput> = (data) => {
    mutateAsync({
      title: data.title.trim(),
      isActive: false,

      costOfOneCourierVisit: Number(data.costOfOneCourierVisit),
      fuelCostPerOrder: Number(data.fuelCostPerOrder),
      totalDepreciationPerOrder: Number(data.totalDepreciationPerOrder),
      tax: Number(data.tax),
      bankCommission: Number(data.bankCommission),
      plannedMarkup: Number(data.plannedMarkup),
    }).then(() => {
      reset();
    });
  };

  return (
    <Form className="flex flex-col pt-4 pr-4" onSubmit={handleSubmit(onSubmit)}>
      <div className="flex flex-row gap-2 justify-between h-12 items-center w-full">
        <p className="font-bold text-xl">Создать базовую цену</p>

        <Button variant="primary" isPending={isPending} type="submit">
          Сохранить
        </Button>
      </div>

      <div className="container mt-6 gap-4 flex flex-col max-w-[40rem]">
        <TextField isInvalid={!!errors.title?.message}>
          <Label>Название</Label>
          <Input {...register("title", { required: "Нужно заполнить поле" })} />
          <FieldError>{errors.title?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.costOfOneCourierVisit?.message}>
          <Label>Себестоимость одного выезда курьера</Label>
          <Input
            defaultValue="0"
            {...register("costOfOneCourierVisit", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.costOfOneCourierVisit?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.fuelCostPerOrder?.message}>
          <Label>Себестоимость топлива на 1 заказ</Label>
          <Input
            defaultValue="0"
            {...register("fuelCostPerOrder", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.fuelCostPerOrder?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.totalDepreciationPerOrder?.message}>
          <Label>Итоговая амортизация на заказ</Label>
          <Input
            defaultValue="0"
            {...register("totalDepreciationPerOrder", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.totalDepreciationPerOrder?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.tax?.message}>
          <Label>Налог в %</Label>
          <Input
            defaultValue="0"
            {...register("tax", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.tax?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.bankCommission?.message}>
          <Label>Комиссия банка в %</Label>
          <Input
            defaultValue="0"
            {...register("bankCommission", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.bankCommission?.message}</FieldError>
        </TextField>

        <TextField isInvalid={!!errors.plannedMarkup?.message}>
          <Label>Плановая наценка в %</Label>
          <Input
            defaultValue="0"
            {...register("plannedMarkup", {
              required: "Нужно заполнить поле",
            })}
          />
          <FieldError>{errors.plannedMarkup?.message}</FieldError>
        </TextField>
      </div>
    </Form>
  );
}
